package ui.campaign.detailv2.editor.feature

import common.frontend.api.Io
import common.frontend.api.Io.Campaign
import io.Repository
import kotlinx.datetime.LocalDate
import kotlin.math.roundToLong

class FeatureCounterImpression(config: Campaign) : FeatureCounter(config) {

    override fun calculateUsage(
        date: LocalDate,
        doyEntry: Io.ListingCampaignDevicesCheck.Entry,
        daySpace: Long,

        companyRepeats: Long,
        companyDuration: Long,

        campaignRepeats: Long,
        campaignDuration: Long
    ): DayInfo {

        val timeSum = daySpace.toDouble() / oneH
        val impressionsCountNew = (timeSum * campaignRepeats.toDouble()).roundToLong()

        val pctNow = ((doyEntry.sum.toDouble() / oneH)).toFloat()
        val pctFuture = (((doyEntry.sum.toDouble() + (campaignRepeats.toDouble() * campaignDuration.toDouble())) / oneH)).toFloat()

        return DayInfo(
            date = date,
            impressionSum = impressionsCountNew,
            usageNow = pctNow,
            usageFuture = pctFuture,
            canBeUsed = pctFuture <= 1F,
            inCampaignRange = campaignRepeats > 0
        )
    }

    override suspend fun loadStatesInternal(companyId: Long, campaignId: Long): Io.ListingCampaignDevicesCheck {
        return Repository.api.campaign.devicesCheckImpression(companyId, campaignId)
    }
}